export default __webpack_public_path__ + "static/media/legends.icon.0792b640.png";